import apiClient from '$utils/apiClient';
import submitSignedRequestForm from './submitSignedRequestForm';

const LTI_CONSUMER_URL = 'lti-consumer';

const signRequestParameters = async ({ requestData }) => {
  const { data } = await apiClient.post(LTI_CONSUMER_URL, requestData, {
    withCredentials: true,
  });

  return data;
};

const launchTurnitinAssignment = async ({ user, assignment, spaceId }) => {
  const {
    id: assignmentId,
    description,
    title,
    startDate,
    gradesReleasedAt,
    endDate,
  } = assignment;

  const { firstName, lastName, email } = user;

  const signedParams = await signRequestParameters({
    requestData: {
      assignmentId,
      spaceId,
      description,
      dueDate: endDate,
      title,
      startDate,
      gradesReleasedAt,
      firstName,
      lastName,
      email,
    },
  });

  submitSignedRequestForm(signedParams);
};

export default launchTurnitinAssignment;
